import React, { Fragment } from 'react'
import { graphql } from 'gatsby'

import { getProject } from '../../projects'
import {
  ProjectLayout,
  ProjectIntro,
  Title,
  Paragraph,
} from '../../layouts/project'

import { useNavbarTheme } from '../../contexts/NavbarTheme'

import { media } from '../../styles/tools'

import { AutoFade, AutoSlide } from '../../components/Animated'
import Wrapper from '../../components/Wrapper'
import Space from '../../components/Space'
import VideoPlayer from '../../components/VideoPlayer'

import Logo from '../../assets/pages/work/lafc/Logo.js'

export const query = graphql`
  {
    headerImage: file(relativePath: { eq: "pages/work/lafc.jpg" }) {
      ...windowWide
    }
    facebookImage: file(relativePath: { eq: "pages/work/lafc.jpg" }) {
      ...facebookShareImage
    }
    twitterImage: file(relativePath: { eq: "pages/work/lafc.jpg" }) {
      ...twitterShareImage
    }
  }
`

let project = getProject('lafc')

export default ({ data }) => {
  project = {
    ...project,
    headerImage: data.headerImage.childImageSharp.fluid,
    facebookImage: data.facebookImage.childImageSharp.fixed.src,
    twitterImage: data.twitterImage.childImageSharp.fixed.src,
    logo: <Logo />,
  }

  useNavbarTheme('dark')

  return (
    <ProjectLayout project={project}>
      <ProjectIntro
        project={project}
        text={
          <Fragment>
            <AutoFade>
              <Title as="h1" css={{ maxWidth: '10em', color: '#f3d066' }}>
                Going Metro with Latif Blessing
              </Title>
            </AutoFade>
            <Space y={32} />
            <AutoFade>
              <Paragraph>
                We were thrilled to collaborate with Los Angeles’ newest sports
                team, LAFC and the talented crew at Friendly Filmworks to tell
                fans how to get to the new Banc of California Stadium in
                Exposition Park via the Los Angeles Metro Expo Line. With LAFC
                star winger Latif Blessing, we created an ad showing Latif using
                his skills to shortcut the heavy LA traffic and opting for the
                Metro instead. The video can be seen playing on screens at the
                Banc of California Stadium promoting the Metro + LAFC
                partnership throughout the 2018 season.
              </Paragraph>
            </AutoFade>
          </Fragment>
        }
      >
        <Space y={{ mobile: 60, tablet: 100 }} />
        Intro
      </ProjectIntro>
      <Wrapper>
        <Space y="25vw" />
        <Space y={{ mobile: 80, tablet: 150 }} />
        Content
      </Wrapper>
    </ProjectLayout>
  )
}
